
import { energyCardsSrcArray } from 'assets/img/cards/energyCards.js';
import React from 'react';
import styles from './prepaidCard.module.scss';

const CARD_WIDTH_PX = 140;
const CARD_GAP_PX = 10;

const generateKeyframe = (name, start, end) => {
    return `
    @keyframes ${name} {
        from {
            transform: translate(${start}px, 0);
          }
        
          to {
            transform: translate(${end}px, 0);
          }
    }
  `;
}

export const PrepaidLoadingAnimation = () => {
    const cardsWidth = ((CARD_WIDTH_PX + CARD_GAP_PX) * energyCardsSrcArray.length);

    const createSlidingBock = (animationName) => {
        return <div style={{ position: 'absolute', display: 'flex', gap: `${CARD_GAP_PX}px`, paddingRight: `${CARD_GAP_PX}`, animation: `${animationName} 15s linear infinite` }}>
            {energyCardsSrcArray.map((img, i) =>
                <img alt='' key={i} width={CARD_WIDTH_PX} src={img} />
            )}
        </div>;
    }

    return <div>
        <style>
            {generateKeyframe('slideFromLeft', -cardsWidth, 0)}
            {generateKeyframe('slideToRight', 0, cardsWidth)}
        </style>

        <div className={styles.loadingBanner}>
            {createSlidingBock('slideFromLeft')}
            {createSlidingBock('slideToRight')}
        </div >
    </div>
}